import React from 'react'
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'


function RecentReports() {
  return (
    <IncludeSideBar>
        <div>
            <p>
                Here we are displaying the recent reports.
            </p>
        </div>
    </IncludeSideBar>
  )
}

export default RecentReports